export default "__VITE_ASSET__24d9a973__"